/*
  Download a Plotly figure as PNG or SVG, for use with
  components/common/ExportPlotDialog.vue.

  The figure is redrawn off-screen rather than captured from the page. WebGL
  traces (scattergl) are swapped for their SVG equivalent first: Plotly can only
  embed WebGL output in an SVG as a raster image, which defeats the point of
  exporting a vector format.
*/
import Plotly from 'plotly.js-dist';

/**
 * The same traces with WebGL types replaced by their SVG counterparts.
 */
export function withoutWebGL(data) {
  return data.map(trace =>
    trace.type === 'scattergl' ? { ...trace, type: 'scatter' } : trace
  );
}

/**
 * @param data Plotly traces, as drawn on screen
 * @param layout Plotly layout, as drawn on screen
 * @param options {format: 'png' | 'svg', filename (no extension), width, height}
 */
export async function downloadPlotlyFigure(data, layout, options) {
  const { format = 'png', filename = 'export', width, height } = options;

  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.left = '-10000px';
  container.style.top = '0';
  container.style.width = `${width}px`;
  container.style.height = `${height}px`;
  document.body.appendChild(container);

  try {
    await Plotly.newPlot(
      container,
      withoutWebGL(data),
      { ...layout, width, height, autosize: false },
      { staticPlot: true, displaylogo: false }
    );
    await Plotly.downloadImage(container, { format, filename, width, height });
  } finally {
    Plotly.purge(container);
    document.body.removeChild(container);
  }
}
